var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87221 19.7674L6.38086 12.137C8.63085 11.4522 8.23955 11.7457 10.783 11.9413C9.76563 14.6805 11.0765 18.3326 11.5656 19.2783L9.87221 19.7674Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.155 0.300049C12.729 3.19569 4.58984 7.05003 4.58984 7.05003C4.58984 7.05003 4.58966 9.78916 5.95941 12.3326C10.655 11.55 16.2637 12.6587 18.4811 13.3109C18.3833 7.76743 17.2094 3.91961 15.155 0.300049Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17606 12.5283C4.08041 11.1978 3.80649 8.51742 3.80649 7.34351C2.6978 7.37611 0.597805 8.10655 1.06737 10.7674C1.55658 12.5283 3.31736 13.1152 5.17606 12.5283Z",
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6313,
    cy: 6.36517,
    r: 1.36956,
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.a916d93095e03c41248f61af534a22c6.svg";
export { ForwardRef as ReactComponent };